/*
 * @Author: liyifan 
 * @Date: 2024-09-05 18:17:43 
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-09-11 16:33:11
 * @description 促销价
 */
import {getServerTime} from '@utils/fetch.js'


export async function InitPromotionaPrice () {
    const startTime = $('.collection-product-main').data('start-time') || ''
    const endTime = $('.collection-product-main').data('end-time') || ''
    if (startTime && endTime) {
        const { data} = await getServerTime()
        const serverTime = new Date(data.datetime).getTime()
        // 判断开始时间和结束时间
        const startTimeStr = new Date(startTime).getTime()
        const endTimeStr = new Date(endTime).getTime()
        if (serverTime > startTimeStr && serverTime < endTimeStr) {
            // 判断每一个产品是否具有促销价，如果有促销价则展示，没有则展示原价
            $('.product-content-main').each(function() {
                const promotionaPrice = $(this).find('.promotiona-price').text()
                if(promotionaPrice) {
                    $(this).find('.promotiona-price').show()
                    $(this).find('.origin-promotiona-price').show()
                } else {
                    $(this).find('.real-price').show()
                    $(this).find('.origin-compare-price').show()
                }
            })
        } else {
            $('.real-price').show()
            $('.origin-compare-price').show()
        }
    } else {
        $('.real-price').show()
        $('.origin-compare-price').show()
    }
} 